import { MPDIcon } from "../icon";
import { MPDIconObj } from "../icon/icon-list";

export const AssetsGallery = () => {
    return (
        <div style={{ display: "flex", gap: "10px", flexWrap: "wrap", overflow: "auto", padding: '20px' }}>
            {Object.keys(MPDIconObj).map((iconKey) => {
                return (
                    <div
                        style={{
                            border: "1px solid crimson",
                            background: "#f8d6ce",
                            width: "150px",
                            height: "150px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            flexDirection: "column"
                        }}
                    >
                        <MPDIcon name={iconKey} />
                        <h6 style={{ textAlign: "center" }}>{iconKey}</h6>
                    </div>
                );
            })}
        </div>
    );
};
